import { Divider, withStyles } from '@material-ui/core';

export default withStyles({
    root: {
        marginTop: 10,
        marginBottom: 10,
        backgroundColor: 'whitesmoke',
    },
})(Divider);
